import FlowioSelect from "./FlowioSelect";

export default FlowioSelect;
export type { FlowioSelectProps } from "./FlowioSelect";
